module.exports = __webpack_public_path__ + "img/share-guide.f9eec976.png";